import React from 'react';

const UCount = (props) => {
    return (
        <React.Fragment>
            <span className="u_count"/>
        </React.Fragment>
    );
};

export default UCount;